import { Star } from 'lucide-react';

/**
 * Five gold stars (partial ratings round to the nearest half via fill opacity).
 *
 *   <StarRating />                 // 5 of 5
 *   <StarRating rating={4.8} size="lg" label="4.8 out of 5 on Google" />
 */
export interface StarRatingProps {
  rating?: number;
  max?: number;
  size?: 'md' | 'lg';
  /** Accessible label; defaults to "<rating> out of <max> stars". */
  label?: string;
  className?: string;
}

export default function StarRating({ rating = 5, max = 5, size = 'md', label, className = '' }: StarRatingProps) {
  const cls = ['ve-stars', size === 'lg' ? 've-stars--lg' : '', className].filter(Boolean).join(' ');
  const text = label ?? `${rating} out of ${max} stars`;
  return (
    <span className={cls} role="img" aria-label={text}>
      {Array.from({ length: max }, (_, i) => {
        const fill = Math.max(0, Math.min(1, rating - i));
        return (
          <Star
            key={i}
            aria-hidden="true"
            focusable="false"
            fill="currentColor"
            strokeWidth={1.5}
            style={fill < 1 ? { opacity: fill >= 0.5 ? 0.6 : 0.25 } : undefined}
          />
        );
      })}
    </span>
  );
}
